module.exports = __webpack_public_path__ + "img/bj_doctor_banner.1e0c6d7f.png";